import createAction from 'redux-actions/lib/createAction';

export const INPUT_MANUAL = 'addressLookupActions/INPUT_MANUAL';
export const INPUT_SEARCH = 'addressLookupActions/INPUT_SEARCH';

export const inputManual = createAction(INPUT_MANUAL);
export const inputSearch = createAction(INPUT_SEARCH);
